  const guestLinks = [
    ['/about_us', 'ABOUT US'],
    ['/terms_of_service', 'TERMS OF SERVICE'],
    ['/privacy_policy', 'PRIVACY POLICY'],
    ['/users/sign_in', 'LOG IN'],
    ['/users/sign_up', 'SIGN UP']
  ]

  const loggedLinks = [
    ['/', 'DASHBOARD'],
    ['/cpd', 'CPD LOCKER'],
    ['/users/profile', 'PROFILE'],
    ['/about_us', 'ABOUT US'],
  ]

  const loggedLinksAsConsultantOrHD = [
    ['/', 'DASHBOARD'],
    ['/users/profile', 'PROFILE'],
    ['/about_us', 'ABOUT US'],
  ]

  const adminLinks = [
    ['/', 'DASHBOARD OF STATISTICS'],
    ['/users', 'USERS'],
    ['/webinars', 'WEBINARS'],
    ['/sponsors', 'SPONSORS'],
    ['/users_sponsors', 'USER SPONSORS']
  ]

  const retrieveLinks = ({
    logged, role, user
  }) => {
    let links;

    if (logged) {
      if (role == 'admin') {
        links = adminLinks;
      } else {
        if (user.user_type === 'consultant') {
          links = loggedLinksAsConsultantOrHD;
        } else if (user.user_type === 'hospital_doctor') {
          links = loggedLinksAsConsultantOrHD;
        } else {
          links = loggedLinks;
        }
      }
    } else {
      links = guestLinks;
    }
    return links.map(e => ({ link: e[0], text: e[1] }))
  }

  export {
    guestLinks,
    loggedLinks,
    adminLinks,
    retrieveLinks,
    loggedLinksAsConsultantOrHD
  }



/** WEBPACK FOOTER **
 ** ./src/services/navLinks.js
 **/